
import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomeView.vue'
import Sobre from '../views/SobreView.vue'
import Blog from '../views/BlogView.vue'
import BlogDetalhe from '../views/BlogDetalheView.vue'
import FaleConosco from '../views/FaleConoscoView.vue'
import Informacoes from '../views/InformacoesView.vue'
import Produtos from '../views/ProdutosView.vue'
import ProdutosDetalhe from '../views/ProdutosDetalheView.vue'
import TreinamentosEventos from '../views/TreinamentosEventosView.vue'
import EventosDetalhe from '../views/EventosDetalheView.vue'
import Videos from '../views/VideosView.vue'


const routes = [
 { path: '/', name: 'Home', component: Home },
 { path: '/Sobre', name: 'Sobre', component: Sobre },
 { path: '/Noticias', name: 'Blog', component: Blog },
 { path: '/NoticiasDetalhe/:idBlog/:nome', name: 'BlogDetalhe', component: BlogDetalhe },
 { path: '/FaleConosco', name: 'FaleConosco', component: FaleConosco },
 { path: '/Informacoes/:idInformacoes?/:nomeInformacoes?', name: 'Informacoes', component: Informacoes },
 { path: '/Produtos/:idSegmentoProduto?/:nomeSegmento?', name: 'Produtos', component: Produtos},
 { path: '/ProdutosPesquisa/:chavepesquisa?', name: 'ProdutosPesquisa', component: Produtos},
 { path: '/ProdutosDetalhe/:idProduto/:nomeProduto', name: 'ProdutosDetalhe', component: ProdutosDetalhe},
{ path: '/Videos', name: 'Videos', component: Videos },
{ path: '/Eventos/:idEvento?', name: 'TreinamentosEventos', component: TreinamentosEventos },
{ path: '/EventosDetalhe/:idTreinamento/:nome', name: 'EventosDetalhe', component: EventosDetalhe },
{ path: '/:catchAll(.*)', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
  next()
})

export default router
